<div class="site-list-container w-full h-full p-4 md:p-6 flex flex-col gap-4">
  <h1 class="text-2xl font-bold mb-2 text-primary-container-contrast">現場一覧</h1>

  <!-- Filter bar -->
  <div class="flex flex-wrap gap-4 items-center bg-primary-container p-4 rounded-lg shadow-sm">
    <mat-form-field appearance="outline" class="w-full sm:w-auto">
      <mat-label>現場名</mat-label>
      <input matInput [ngModel]="filterCriteria().name" (ngModelChange)="updateFilter('name', $event)" placeholder="現場名で検索">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full sm:w-auto">
      <mat-label>管理部署</mat-label>
      <mat-select [ngModel]="filterCriteria().departmentId" (ngModelChange)="updateFilter('departmentId', $event)">
        <mat-option [value]="null">すべて</mat-option>
        @for (dept of departments(); track dept.id) {
          <mat-option [value]="dept.id">
            {{ dept.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full sm:w-auto">
      <mat-label>WBGT状況</mat-label>
      <mat-select [ngModel]="filterCriteria().wbgtStatus" (ngModelChange)="updateFilter('wbgtStatus', $event)">
        <mat-option [value]="null">すべて</mat-option>
        <mat-option value="normal">ほぼ安全</mat-option>
        <mat-option value="caution">注意</mat-option>
        <mat-option value="alert">警戒</mat-option>
        <mat-option value="danger">危険</mat-option>
        <mat-option value="stopped">停止</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full sm:w-auto">
      <mat-label>風速状況</mat-label>
      <mat-select [ngModel]="filterCriteria().windSpeedStatus" (ngModelChange)="updateFilter('windSpeedStatus', $event)">
        <mat-option [value]="null">すべて</mat-option>
        <mat-option value="normal">ほぼ安全</mat-option>
        <mat-option value="caution">注意</mat-option>
        <mat-option value="alert">警戒</mat-option>
        <mat-option value="danger">警報</mat-option>
        <mat-option value="stopped">停止</mat-option>
      </mat-select>
    </mat-form-field>

    <button matButton (click)="clearFilters()" class="ml-auto">
      クリア
    </button>
  </div>

  <!-- Table -->
  <div class="table-container w-full overflow-x-auto rounded-lg shadow-sm flex-1 bg-(--mat-sys-surface)">
    <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onSortChange($event)" class="w-full">
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 現場名 </th>
        <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
      </ng-container>

      <!-- Department Column -->
      <ng-container matColumnDef="managementDepartmentName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 管理部署 </th>
        <td mat-cell *matCellDef="let row"> {{ row.managementDepartmentName }} </td>
      </ng-container>

      <!-- WBGT Status Column -->
      <ng-container matColumnDef="wbgtStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> WBGT状況 </th>
        <td mat-cell *matCellDef="let row">
          <span [class]="getWbgtBadgeClass(row.wbgtStatusNo)">
            {{ row.wbgtStatusLabel || getStatusLabel(row.wbgtStatus) }}
          </span>
        </td>
      </ng-container>

      <!-- WBGT Value Column -->
      <ng-container matColumnDef="wbgtValue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> WBGT値 </th>
        <td mat-cell *matCellDef="let row"> {{ row.wbgtValue != null ? row.wbgtValue : '-' }} </td>
      </ng-container>

      <!-- Wind Speed Status Column -->
      <ng-container matColumnDef="windSpeedStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 風速状況 </th>
        <td mat-cell *matCellDef="let row">
          <span [class]="getWindBadgeClass(row.windSpeedStatusNo)">
            {{ row.windSpeedStatusLabel || getStatusLabel(row.windSpeedStatus) }}
          </span>
        </td>
      </ng-container>

      <!-- Wind Speed Value Column -->
      <ng-container matColumnDef="windSpeedValue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 風速 (m/s) </th>
        <td mat-cell *matCellDef="let row"> {{ row.windSpeedValue != null ? row.windSpeedValue : '-' }} </td>
      </ng-container>

      <!-- Wind Direction Column -->
      <ng-container matColumnDef="windDirection">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 風向 </th>
        <td mat-cell *matCellDef="let row"> {{ row.windDirection || '-' }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
          (click)="onRowClick(row)"
          (keydown.enter)="onRowClick(row)"
          (keydown.space)="onRowClick(row); $event.preventDefault()"
          tabindex="0"
          role="button"
          [attr.aria-label]="'現場「' + row.name + '」の詳細を開く'"
          class="hover:bg-gray-50 cursor-pointer transition-colors duration-150">
      </tr>
      
      <!-- No Data Row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-8 text-gray-500" [attr.colspan]="displayedColumns.length">
          該当する現場データがありません。
        </td>
      </tr>
    </table>
  </div>
</div>
